<template>
  <form>
    <div class="row">
      <div class="col-lg-12">
        <h3 class="card-title">{{$t('medium_grant.diligence__1_capacity_questionaire')}}</h3>
        <p>{{$t('medium_grant.diligence__1_capacity_questionaire_sub')}}</p>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-lg-3">
        <div class="form-group">
          <textarea
            class="form-control"
            disabled
            name="diligence.applicantName"
            v-model="GrantForm.model.technical.nameOfLeadOrg"
            :label="$t('medium_grant.diligence__1_applicant_name')"
            :placeholder="$t('medium_grant.diligence__1_applicant_name')"
          >
          </textarea>
        </div>
        <div class="form-group">
          <textarea
            class="form-control"
            disabled
            name="diligence.proposalNo"
            v-model="GrantForm.reference"
            :label="$t('medium_grant.diligence__1_proposal_no')"
            :placeholder="$t('medium_grant.diligence__1_proposal_no')"
          >
          </textarea>
        </div>
        <div class="form-group">
          <textarea
            class="form-control"
            disabled
            name="diligence.projectProposalName"
            v-model="GrantForm.title"
            :label="$t('medium_grant.diligence__1_project_proposal_name')"
            :placeholder="$t('medium_grant.diligence__1_project_proposal_name')"
          >
          </textarea>
        </div>
        <div class="form-group">
          <textarea
            class="form-control"
            disabled
            name="diligence.amountRequested"
            v-model="GrantForm.model.technical.totalCoFunding"
            :label="$t('medium_grant.diligence__1_amount_requested')"
            :placeholder="$t('medium_grant.diligence__1_amount_requested')"
          >
          </textarea>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
  import {GrantForm} from "@/services";

  export default {
    data() {
      return {
        GrantForm,
      }
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model);
          return res;
        });
      }
    }
  }
</script>